module.exports = __webpack_public_path__ + "static/assets/cd04b17abf51f572df1b1f485d59f6c3.svg";